<template>
  <transition name="fade">
    <main v-if="showComponent">
      <nav-component />
			<router-view />
    </main>
  </transition>
</template>

<script>
	import { auth } from '../../firebase'
	import Nav from './Nav.vue'

	export default {
    data() {
			return {
        showComponent: false
			}
    },
    mounted() {
      setTimeout(() => {
        this.showComponent = true
      }, 1000)
    },
		components: {
			NavComponent: Nav
    },
    created() {
      this.currentUser()
    },
    methods: {
      currentUser() {
				auth.onAuthStateChanged( user => {
          if(user){
            if( user.email == 'client@soleol.ch' ) {
              this.$router.push('/user/files')
            } else {
              this.$router.push('/admin/files')
            }
          } else{
						this.$router.push('/')
          }
				})
			},
    }
	}
</script>

<style>
  .fade-enter-active{
    transition: all .5s ease-out;
  }
  .fade-leave-active{
    transition: all .5s ease-out;
  }
  .fade-enter, .fade-leave-to{
    opacity: 0;
    filter: blur(3px);
  }
</style>


// WEBPACK FOOTER //
// src/components/user/Dashboard.vue